import setReduxAction from 'modules/redux/actions/set'
import validateReduxUtil from 'modules/redux/utils/validate'
import { getObjectUtil } from 'packages/src'

/**
 * Validates the object at the given path.
 * @param {Object} params
 *        {string} params.path
 *        {Object} [params.options]
 */
function validateReduxAction (params) {
  return (dispatch, getState) => {
    const { payload } = params
    const {
      path,
      options
    } = payload
    const instance = getObjectUtil(getState(), path)
    const validation = validateReduxUtil(instance, options)
    if (!validation) {
      return
    }
    const validationPath = `${path}.validation`
    dispatch(
      setReduxAction({
        type: params.type,
        payload: {
          path: validationPath,
          value: validation
        }
      })
    )
  }
}

export default validateReduxAction
